function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import { C_EBON } from '@bbc/psammead-styles/colours';
import { GEL_SPACING_HLF, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
var defaultAttrs = {
  focusable: 'false',
  'aria-hidden': 'true'
};
var coreAttrs = {
  viewBox: '0 0 32 32',
  width: GEL_SPACING_DBL,
  height: GEL_SPACING_DBL
};
var CoreIcon = /*#__PURE__*/styled.svg.withConfig({
  displayName: "CoreIcon",
  componentId: "sc-1eqhzay-0"
})(["vertical-align:middle;margin:0 ", ";color:", ";fill:currentColor;"], GEL_SPACING_HLF, C_EBON);
var ClockIcon = /*#__PURE__*/styled(CoreIcon).withConfig({
  displayName: "ClockIcon",
  componentId: "sc-1eqhzay-1"
})(["width:0.725rem;height:0.725rem;"]);
var CoreIcons = {
  alert: /*#__PURE__*/React.createElement(CoreIcon, _extends({}, defaultAttrs, coreAttrs), /*#__PURE__*/React.createElement("path", {
    d: "M16 2L0 30h32zm2 25h-4v-4h4zm-4-6V11h4v10z"
  })),
  info: /*#__PURE__*/React.createElement(CoreIcon, _extends({}, defaultAttrs, coreAttrs), /*#__PURE__*/React.createElement("path", {
    d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm2 25h-4V13h4zm0-14h-4V7h4z"
  })),
  clock: /*#__PURE__*/React.createElement(ClockIcon, _extends({
    viewBox: "0 0 13 13",
    width: "13",
    height: "13"
  }, defaultAttrs), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0A6.5 6.5 0 1013 6.5 6.5 6.5 0 006.5 0zm0 11.5a5 5 0 115-5 5 5 0 01-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34 2.9h-1v3.8L9.4 8.57l.41-.56-2.47-1.89V2.9z"
  }))
};
export default CoreIcons;